// DRM Kitchen Mock Data - Tüm Logolar

export const brandData = {
  mainBrand: {
    name: "DRM Kitchen",
    tagline: "Lezzet Dünyasının Merkezi",
    instagram: "@drmkitchen35",
    instagramUrl: "https://instagram.com/drmkitchen35",
    logo: "/logos/logo-main.png"
  },
  contact: {
    phone: "0 542 237 54 45",
    email: "info@drmkitchen.com.tr",
    address: "Kazım Dirik Mahallesi Kurtuluş Caddesi No:11/B Bornova- İZMİR"
  },
  banners: [
    { id: 1, src: "/banners/b1.svg", alt: "Banner 1" },
    { id: 2, src: "/banners/b2.svg", alt: "Banner 2" },
    { id: 3, src: "/banners/b3.svg", alt: "Banner 3" },
    { id: 4, src: "/banners/b4.svg", alt: "Banner 4" },
    { id: 5, src: "/banners/b5.svg", alt: "Banner 5" }
  ],
  subBrands: [
    {
      id: 1,
      name: "Altı Üstü Pilav",
      description: "Geleneksel Türk mutfağının vazgeçilmezi",
      instagram: "@alti.ustupilav",
      instagramUrl: "https://instagram.com/alti.ustupilav",
      color: "#1a1a1a",
      logo: "/logos/logo1.png"
    },
    {
      id: 2,
      name: "Chickenwich",
      description: "Enfes tavuk sandviçlerin adresi",
      instagram: "@chickenwich35",
      instagramUrl: "https://instagram.com/chickenwich35",
      color: "#E53935",
      logo: "/logos/logo2.png"
    },
    {
      id: 3,
      name: "DRM American Hotdog",
      description: "Amerikan usulü hotdog deneyimi",
      instagram: "@drmamericanhotdog",
      instagramUrl: "https://instagram.com/drmamericanhotdog",
      color: "#1565C0",
      logo: "/logos/logo3.png"
    },
    {
      id: 4,
      name: "DRM Pankek",
      description: "Tatlı anlarınızın vazgeçilmezi",
      instagram: "@drmpankek",
      instagramUrl: "https://instagram.com/drmpankek",
      color: "#6D4C41",
      logo: "/logos/logo4.png"
    },
    {
      id: 5,
      name: "Kurufasulyeci İbrahim",
      description: "Ev yapımı lezzetler, geleneksel tatlar",
      instagram: "@kurufasulyeciibrahim",
      instagramUrl: "https://instagram.com/kurufasulyeciibrahim",
      color: "#558B2F",
      logo: "/logos/logo5.png"
    },
    {
      id: 6,
      name: "CrispyLab",
      description: "Çıtır çıtır lezzetlerin laboratuvarı",
      instagram: "@crispylab35",
      instagramUrl: "https://instagram.com/crispylab35",
      color: "#00897B",
      logo: "/logos/logo6.png"
    },
    {
      id: 7,
      name: "FryBro Chicken",
      description: "Kızarmış tavuğun en lezzetli hali",
      instagram: "@frybro.35",
      instagramUrl: "https://instagram.com/frybro.35",
      color: "#7B1F3A",
      logo: "/logos/logo7.png"
    }
  ]
};
